import React, { useState } from 'react';
import { Badge, ChevronDown } from '@opendate-app/setlist';

import './TicketDrawerSection.css';

const TicketDrawerSection = ({ title, summary, edited, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="ticket-drawer-section">
      <button
        type="button"
        className="ticket-drawer-section-header"
        data-testid="ticket-drawer-section-header"
        aria-expanded={open}
        onClick={() => setOpen((prevOpen) => !prevOpen)}
      >
        <span className="ticket-drawer-section-heading">
          <span className="ticket-drawer-section-title">{title}</span>
          {summary ? <span className="ticket-drawer-section-summary">{summary}</span> : null}
        </span>
        <span className="ticket-drawer-section-meta">
          <Badge color={edited ? 'warning' : 'gray'}>{edited ? 'EDITED' : 'DEFAULTS'}</Badge>
          <ChevronDown
            width={16}
            height={16}
            className={`ticket-drawer-section-chevron ${open ? 'ticket-drawer-section-chevron--open' : ''}`}
            aria-hidden="true"
          />
        </span>
      </button>
      {open ? <div className="ticket-drawer-section-body">{children}</div> : null}
    </div>
  );
};

export default TicketDrawerSection;
